module.exports = __webpack_public_path__ + "img/cost-icon__sport_bar.bf660c06.svg";